module.exports = __webpack_public_path__ + "b9cd0a53182ee274a388399b8b7fa7d3.png";